/**
 * Where leaving the Funding plan goes: the header's back button and the overview step's Back both
 * use this, so they always agree. Opened from the clients dashboard it returns there; otherwise
 * an advisor returns to the Financing plan and a client planning for themselves to their Summary.
 */
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { SessionType } from '@shared';
import { selectFeatureFlags, selectSession } from '@client/model/selectors';
import { useBackDestination } from '@/shared/hooks/use-back-destination';

export function useGuidedPlanningBack() {
  const { clientId } = useParams<{ clientId: string }>();
  const { sessionType } = useSelector(selectSession);
  const featureFlags = useSelector(selectFeatureFlags);
  const isD2C = sessionType === SessionType.client && !!featureFlags.d2cMode;

  return useBackDestination(
    isD2C
      ? { label: 'Back to Summary', path: `/clients/${clientId}/onboarding/care-phases-summary` }
      : {
          label: 'Back to Financing Plan',
          path: `/clients/${clientId}/onboarding/funding-sources`,
        },
  );
}
